import React from 'react';
import {observer} from 'mobx-react';
import {QuickTip} from 'components';
import {AlertModal, ModalButtons} from 'components/modals';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const ShareWithRevieweeModal = observer(({uiState}) => {
  const {shareWithRevieweeModalOpen, canShareReviewee, revieweeName, reviewee, managerReviewerName} = uiState;
  if (!shareWithRevieweeModalOpen) return null;

  return (
    <AlertModal
      translate={false}
      isOpen={uiState.shareWithRevieweeModalOpen}
      onHide={() => uiState.closeShareWithRevieweeModal()}
      size='md'
      header={t('performance_reviews.view.Close')}
    >
      {!canShareReviewee && <div className='mb2'>
        <QuickTip
          trait='caution'
          header={<FormattedMessage id='performance_reviews.view.MANAGER_WARNING_HEADER'/>}
          paragraphs={[
            <FormattedMessage
              id='performance_reviews.view.MANAGER_WARNING_MESSAGE'
              values={{
                reviewerName: managerReviewerName,
                revieweeName: revieweeName
              }}
            />
          ]}
        />
      </div>}
      <div>
        <FormattedMessage
          id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_1' values={{revieweeName: revieweeName}}
        />
      </div>
      {!reviewee.canViewAllReviews && <div className='mt2'>
        <FormattedMessage
          id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_2' values={{revieweeName: revieweeName}}
        />
      </div>}
      <ModalButtons
        saveCaption='performance_reviews.view.Share'
        saveEnabled={canShareReviewee}
        onSave={() => uiState.shareWithReviewee(reviewee)}
        onCancel={() => uiState.closeShareWithRevieweeModal()}
      />
    </AlertModal>
  );
});

export default ShareWithRevieweeModal;
